<ng-template #operatorView>
  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>
    <div class="float-end mb-1">
      <button class="btn btn-yellow ms-1" [routerLink]="['/blackboxes/setup']">
        <app-svg source="icons/feather/cpu" width="16"></app-svg>
        <span class="d-none d-md-inline ps-2" i18n="@@SetupBlackboxButton">Blackbox einrichten</span>
      </button>
    </div>
    </div>
    <ng-container *ngTemplateOutlet="operatorContent"></ng-container>
</ng-template>

<ng-template #operatorContent>
  <div *ngIf="tableReady" [class]="tableView">
    <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" class="table-layout"></app-table>
  </div>

  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
    </div>
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="operatorView"></ng-container>

<router-outlet></router-outlet>
